import superagent from 'superagent';

const webserviceAdmin = process.env.REACT_APP_WEBSERVICE_ADMIN_CARTMX;

export default async function postAdminCarritoMX({ tmbservice, jsonBody, token, getCookie }) {
  const url = `${webserviceAdmin}/${tmbservice}`;
  let response = {};

  const tokenFn = !token ? getCookie('TokenApiAdminMX') : token;

  await superagent
    .patch(url)
    .set('Content-Type', 'application/json')
    .auth(tokenFn, { type: 'bearer' })
    .query(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
